export default __webpack_public_path__ + "static/media/12_2.c592b1b0.jpg";